/** Text helpers shared by the repeatability grid, the 3D gamut plot and the
 *  wizard pages. The capture modes are just "mode 1" / "mode 2". */

export function modeLabel(mode) {
    return `Mode ${mode}`;
}

export function cellStateLabel(cell) {
    if (!cell.repeatable) {
        const failed = Object.entries(cell.modes)
            .filter(([, reading]) => !reading.repeatable)
            .map(([mode]) => modeLabel(mode));
        return `excluded by ΔE00 (${failed.join(", ")})`;
    }
    if (cell.manual_rejected) return "excluded manually";
    return "retained";
}
